// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { IProduct } from '../actionCreators/home/getHomeActions';
import { ProductHistoryRow } from '../../pages/HomePage/components/HistoryTable';
import { RootAction, actionCreatorsList } from '../rootActionCreator';

export interface HomeState {
  isFetching: boolean;
  list: IProduct[];
  homeError: string;
  sorting: {
    sortingKey: keyof ProductHistoryRow;
    isAscending: boolean;
  }
}

const {
  getHomeActions,
  sortHomeHistoryAction
} = actionCreatorsList;

export const initialState: HomeState = {
  isFetching: false,
  list: [],
  homeError: '',
  sorting: {
    sortingKey: 'completionStatus',
    isAscending: true,
  }
};

export default function (state = initialState, action: RootAction): HomeState {
  switch (action.type) {
    case getType(getHomeActions.request): {
      return {
        ...state,
        isFetching: true,
        homeError: ''
      };
    }
    case getType(getHomeActions.success): {
      const { list } = action.payload;
      return {
        ...state,
        isFetching: false,
        list,
      };
    }
    case getType(getHomeActions.failure): {
      return {
        ...state,
        isFetching: false,
        homeError: action.payload.error
      };
    }
    case getType(sortHomeHistoryAction): {
      const nextSortingKey = action.payload;
      return {
        ...state,
        sorting: {
          sortingKey: nextSortingKey,
          isAscending: nextSortingKey === state.sorting.sortingKey ? !state.sorting.isAscending : true
        }
      }
    }
    default: {
      return state;
    }
  }
}
